import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { ReactiveFormsModule, Validators } from '@angular/forms';
import { MatButton } from '@angular/material/button';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInput } from '@angular/material/input';
import { MatToolbarModule } from '@angular/material/toolbar';
import {
  AttachmentsComponent,
  ButtonsContainerComponent,
  TypedFormControl,
  TypedFormGroup,
} from '@principle-theorem/ng-shared';
import { FundingRequest } from '@principle-theorem/principle-core';
import {
  IMohPreApprovalFundingRequest,
  IMohPreApprovalFundingRequestData,
} from '@principle-theorem/principle-core/interfaces';
import { IAttachment, WithRef } from '@principle-theorem/shared';

export type MohConfirmPreApprovalForm = Pick<
  IMohPreApprovalFundingRequestData,
  'approvalNumber'
>;

@Component({
  selector: 'pr-moh-confirm-pre-approval-dialog',
  imports: [
    MatToolbarModule,
    AttachmentsComponent,
    ReactiveFormsModule,
    MatFormFieldModule,
    CommonModule,
    MatInput,
    MatButton,
    ButtonsContainerComponent,
  ],
  templateUrl: './moh-confirm-pre-approval-dialog.component.html',
  styleUrl: './moh-confirm-pre-approval-dialog.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class MohConfirmPreApprovalDialogComponent {
  private _dialog = inject(MatDialogRef);
  approvalRequest =
    inject<WithRef<IMohPreApprovalFundingRequest>>(MAT_DIALOG_DATA);

  form = new TypedFormGroup<MohConfirmPreApprovalForm>({
    approvalNumber: new TypedFormControl<string>('', Validators.required),
  });

  attachments$ = FundingRequest.attachments$(this.approvalRequest);
  storagePath = FundingRequest.storagePath(this.approvalRequest);

  async addAttachment(attachment: IAttachment): Promise<void> {
    await FundingRequest.addAttachment(this.approvalRequest, attachment);
  }

  async removeAttachment(attachment: WithRef<IAttachment>): Promise<void> {
    await FundingRequest.removeAttachment(attachment);
  }

  save(): void {
    if (this.form.invalid) {
      this.form.markAllAsTouched();
      return;
    }

    this._dialog.close(this.form.getRawValue());
  }
}
